import { render, staticRenderFns } from "./WhInventory.vue?vue&type=template&id=9de566e4&scoped=true"
import script from "./WhInventory.vue?vue&type=script&lang=js"
export * from "./WhInventory.vue?vue&type=script&lang=js"
import style0 from "./WhInventory.vue?vue&type=style&index=0&id=9de566e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de566e4",
  null
  
)

export default component.exports